import { render, staticRenderFns } from "./BreadcrumbColored.vue?vue&type=template&id=1c8fcd4d"
import script from "./BreadcrumbColored.vue?vue&type=script&lang=js"
export * from "./BreadcrumbColored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports